import React from 'react';

const KVKK = () => {
  const lastUpdated = '25 Ekim 2025';

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              KVKK Aydınlatma Metni
            </h1>
            <p className="text-lg text-gray-600">
              Son Güncelleme: {lastUpdated}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            {/* Giriş */}
            <p className="text-gray-700 leading-relaxed mb-6">
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca,
              kişisel verilerinizin işlenmesine ilişkin olarak sizleri
              bilgilendirmek isteriz. Bu Aydınlatma Metni, ContractCode ("Şirket",
              "biz") tarafından, kişisel verilerinizin nasıl toplandığını,
              işlendiğini, saklandığını ve korunduğunu açıklamaktadır.
            </p>

            {/* Veri Sorumlusu */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              1. Veri Sorumlusu
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verilerinizin işlenmesinden sorumlu olan veri sorumlusu:
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-900 font-semibold mb-2">ContractCode</p>
              <p className="text-gray-700 mb-1">
                Adres: Örnek Mahallesi, Teknoloji Caddesi No: 123, Çankaya,
                Ankara 06000
              </p>
              <p className="text-gray-700 mb-1">
                E-posta: kvkk@contractcode.com.tr
              </p>
              <p className="text-gray-700">Telefon: +90 (312) 123 45 67</p>
            </div>

            {/* İşlenen Kişisel Veriler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              2. İşlenen Kişisel Veriler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Platformumuzda aşağıdaki kategorilerdeki kişisel verileriniz
              işlenebilmektedir:
            </p>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              2.1. Kimlik Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Ad, soyad</li>
              <li>T.C. kimlik numarası (isteğe bağlı)</li>
              <li>Doğum tarihi</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              2.2. İletişim Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>E-posta adresi</li>
              <li>Telefon numarası</li>
              <li>Adres bilgileri</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              2.3. Müşteri İşlem Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Üyelik bilgileri</li>
              <li>Sipariş ve işlem geçmişi</li>
              <li>Oluşturulan belgeler</li>
              <li>Abonelik bilgileri</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              2.4. Finans Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>Ödeme bilgileri (kredi kartı son 4 hanesi)</li>
              <li>Fatura bilgileri</li>
              <li>Vergi kimlik numarası (kurumsal müşteriler için)</li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              2.5. İşlem Güvenliği Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>IP adresi</li>
              <li>Çerez kayıtları</li>
              <li>Tarayıcı bilgileri</li>
              <li>Cihaz bilgileri</li>
              <li>Erişim logları</li>
            </ul>

            {/* İşleme Amaçları */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              3. Kişisel Verilerin İşlenme Amaçları
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Üyelik işlemlerinin gerçekleştirilmesi</li>
              <li>Hizmetlerin sağlanması ve iyileştirilmesi</li>
              <li>Müşteri ilişkileri yönetimi</li>
              <li>Ödeme işlemlerinin yapılması</li>
              <li>Fatura ve finansal raporlama</li>
              <li>Müşteri destek hizmetlerinin sağlanması</li>
              <li>Pazarlama ve reklam faaliyetleri (onay vermeniz halinde)</li>
              <li>Sistem ve işlem güvenliğinin sağlanması</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>Platform performansının analizi ve iyileştirilmesi</li>
              <li>Dolandırıcılık tespiti ve önlenmesi</li>
            </ul>

            {/* İşleme Hukuki Sebepleri */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              4. Kişisel Verilerin İşlenmesinin Hukuki Sebepleri
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen
              aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan ilgili olması</li>
              <li>Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması</li>
              <li>İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için gerekli olması</li>
              <li>Açık rızanızın bulunması</li>
            </ul>

            {/* Veri Aktarımı */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              5. Kişisel Verilerin Aktarılması
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verileriniz, yukarıda belirtilen amaçların yerine
              getirilmesi için gerekli olduğu ölçüde aşağıdaki alıcılara
              aktarılabilmektedir:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Ödeme kuruluşları ve bankalar</li>
              <li>Bulut hizmet sağlayıcıları</li>
              <li>E-posta ve SMS hizmet sağlayıcıları</li>
              <li>Analitik ve reklam platformları</li>
              <li>Hukuki danışmanlar</li>
              <li>Yetkili kamu kurum ve kuruluşları (yasal zorunluluk halinde)</li>
              <li>İş ortakları (açık rızanız dahilinde)</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-6">
              Kişisel verilerinizin yurt dışına aktarımı söz konusu olduğunda,
              KVKK'nın 9. maddesinde öngörülen şartlara uygun hareket
              edilmektedir.
            </p>

            {/* Veri Saklama Süresi */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              6. Kişisel Verilerin Saklama Süresi
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve
              ilgili mevzuatta öngörülen saklama süreleri göz önünde
              bulundurularak saklanmaktadır. Saklama süreleri sona erdiğinde veya
              işleme amacı ortadan kalktığında, kişisel verileriniz silinir, yok
              edilir veya anonim hale getirilir.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              Örnek saklama süreleri:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Üyelik bilgileri: Hesap aktif olduğu sürece</li>
              <li>Finansal kayıtlar: Vergi Usul Kanunu uyarınca 10 yıl</li>
              <li>İletişim kayıtları: 3 yıl</li>
              <li>Log kayıtları: 6 ay - 2 yıl arası (güvenlik ihtiyacına göre)</li>
              <li>Pazarlama onayları: Onay geri çekilene kadar</li>
            </ul>

            {/* Veri Güvenliği */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              7. Kişisel Verilerin Korunması
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Kişisel verilerinizin güvenliğini sağlamak için teknik ve idari
              önlemler almaktayız. Bu önlemler arasında şifreleme, güvenlik
              duvarları, erişim kontrolleri, güvenli sunucular ve düzenli
              güvenlik denetimleri bulunmaktadır. Yetkisiz erişim, kayıp veya
              ifşaya karşı azami özen gösterilmektedir.
            </p>

            {/* KVKK Hakları */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              8. KVKK Kapsamındaki Haklarınız
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK'nın 11. maddesi uyarınca, veri sahibi olarak aşağıdaki
              haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</li>
              <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
              <li>Düzeltme ve silme işlemlerinin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</li>
            </ul>

            {/* Başvuru Yöntemi */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              9. Haklarınızı Kullanma ve Başvuru Yöntemi
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK kapsamındaki haklarınızı kullanmak için aşağıdaki yöntemlerle
              başvurabilirsiniz:
            </p>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              Başvuru Kanalları:
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-4">
              <li>
                <strong>E-posta:</strong> kvkk@contractcode.com.tr (güvenli
                elektronik imza veya mobil imza ile)
              </li>
              <li>
                <strong>Posta:</strong> Örnek Mahallesi, Teknoloji Caddesi No:
                123, Çankaya, Ankara 06000 (kimlik fotokopisi ile)
              </li>
              <li>
                <strong>Sistemimiz üzerinden:</strong> Hesap ayarlarından "KVKK
                Başvurusu" bölümü (yakında)
              </li>
            </ul>

            <h3 className="text-2xl font-semibold text-gray-900 mb-3 mt-6">
              Başvuru Sürecireci:
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Başvurunuz en kısa sürede ve en geç 30 gün içinde yanıtlanacaktır</li>
              <li>İşlemin ayrıca bir maliyet gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir</li>
              <li>Başvurunuzun reddedilmesi, verilen cevabın yetersiz bulunması veya süresinde cevap verilmemesi hallerinde, ret cevabını öğrendiğiniz tarihten itibaren 30 gün içinde Kişisel Verileri Koruma Kurulu'na şikâyette bulunabilirsiniz</li>
            </ul>

            {/* Değişiklikler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              10. Aydınlatma Metninde Değişiklikler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bu Aydınlatma Metni, yasal düzenlemelerdeki değişiklikler veya
              şirketimizin veri işleme faaliyetlerindeki değişiklikler
              doğrultusunda güncellenebilir. Önemli değişiklikler hakkında sizi
              bilgilendireceğiz.
            </p>

            {/* İletişim */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              11. İletişim Bilgileri
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK ile ilgili sorularınız ve talepleriniz için bizimle iletişime
              geçebilirsiniz:
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-900 font-semibold mb-2">
                ContractCode - KVKK Birimi
              </p>
              <p className="text-gray-700 mb-1">
                E-posta: kvkk@contractcode.com.tr
              </p>
              <p className="text-gray-700 mb-1">
                Telefon: +90 (312) 123 45 67
              </p>
              <p className="text-gray-700">
                Adres: Örnek Mahallesi, Teknoloji Caddesi No: 123, Çankaya,
                Ankara 06000
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

KVKK.propTypes = {};

export default KVKK;

